import { memo } from "react";
import { Grid2, IconButton, Link, Typography, Tooltip, Stack } from "@mui/material";
import { ExternalLinks, RouteTo } from "@routing/RouteMap";
import { icon } from "@/app/style/icons";
import { useLocation } from "react-router-dom";
import LogoNew from "@core/components/LogoNew";

/**
 * Wird im {@link Layout} immer als unterstes Element angezeigt.
 */
const Footer = memo(() => {
    const { pathname } = useLocation();
    const currentYear = new Date().getFullYear(); // Stellt sicher, dass das Jahr immer korrekt ist

    return (
        <Grid2 container size={12} alignItems={"center"} pl={1}>
            <Grid2 container size={"grow"} alignItems={"center"}>
                <Grid2 sx={{ opacity: 0.85, display: "flex", alignItems: "center", mb:1 }}>
                    {/* Full-height logo (54px height => size≈145) */}
                    <LogoNew size={120}/>
                </Grid2>

                {/* Text block: stacked vertically */}
                <Grid2 sx={{ ml:3.5, mt:1, flex:1, minWidth:0 }}>
                    <Stack spacing={0.8} alignItems="flex-start">
                        {/* Copyright */}
                        <Link
                            href={ExternalLinks.ESGBOT}
                            underline={"hover"}
                            color="text.primary"
                            variant="nospace"
                            sx={{
                                fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.8rem" },
                                whiteSpace: "nowrap",
                                display: "block",
                                lineHeight: 1,
                            }}
                        >
                            {`© ${currentYear} ESGbot GbR. All rights reserved.`}
                        </Link>

                        {pathname === RouteTo.DASHBOARD && (
                            <Typography
                                variant="caption"
                                fontStyle="italic"
                                sx={{
                                    whiteSpace: 'normal',
                                    fontSize: { xs: '0.56rem', sm: '0.6rem', md: '0.68rem' },
                                    lineHeight: 1.1,
                                    ml: 0,
                                }}
                            >
                                Der ESGbot bietet keine aktive Rechtsberatung. Es können Fehler passieren. Wichtige Informationen müssen immer überprüft werden.
                            </Typography>
                        )}
                    </Stack>
                </Grid2>
            </Grid2>

            <Grid2 container pt={0.25}>
                <Grid2 mr={-0.5}>
                    <IconButton href={ExternalLinks.LINKEDIN} target="_blank" rel="noopener noreferrer">
                        <icon.linkedIn sx={{ color: "semantic.special.linkedin" }} />
                    </IconButton>
                </Grid2>
            </Grid2>
        </Grid2>
    );
});

export default Footer;
